import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthDeco } from '../../store/actions/auth.action';
import { AuthService } from "../../services/auth.service";

@Component({
    selector: 'lib-logout-callback',
    template: ``
})
export class AuthLogoutComponent implements OnInit {

  store = inject(Store<any>);
  route = inject(ActivatedRoute);


  ngOnInit() {
    this.route.queryParamMap.pipe(first()).subscribe(
      (paramMap: ParamMap) => {
        const authDeco = paramMap.get('local') ? new AuthDeco({local: paramMap.get('local')}) : new AuthDeco({});
        this.store.dispatch(authDeco);
      }
    );
  }
}
